/**
 * Packaging document shares RAG ingestion with an identical file (byte duplicate link).
 */
export function isLinkedPackagingDuplicateDocument(document: {
  id: string
  ragDocumentId?: string | null
}): boolean {
  return (
    document.ragDocumentId != null && document.ragDocumentId !== document.id
  )
}

export function linkedPackagingCanonicalDocumentId(document: {
  id: string
  ragDocumentId?: string | null
}): string | null {
  if (!isLinkedPackagingDuplicateDocument(document)) {
    return null
  }
  return document.ragDocumentId ?? null
}
